import BootstrapTable from "react-bootstrap-table-next";
import React from "react";
import './table.scss'
import { Button, Col, Dropdown, Row } from "react-bootstrap";
import { connect } from "react-redux";
import Pagination from "react-js-pagination";
import checkJwt from "./../../../Global/jwtChecker";
import logout from "./../../../Global/logout.js";
import { AiFillEdit } from "react-icons/ai";
import Loader from "./../../../Global/loader";
import GetProviders from "./../../../API/Provider/GetProviders";
import { RiDeleteBin5Line } from "react-icons/ri";
import deleteProvider from "./../../../API/Provider/DeleteProvider.js";
import Modal from "react-modal";
import { store } from "react-notifications-component";
import { withNamespaces } from "react-i18next";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import ButtonWithDropdown from '../../../Global/ButtonWithDropdown'
import { isMobile } from "react-device-detect";
import updateUser from '../../../API/Provider/PutUser'
import history from "../../../history";
import { v4 as uuidv4 } from 'uuid';

export class ProviderList extends React.Component {
    constructor(props) {
        super(props);

        this.prikaziSakrij = this.prikaziSakrij.bind(this);  

        this.state = {
            loading: true,
            showModal: false,
            uuidForDelete: "",
            brojacAktivni: 0,

            customStyles: {
                content: {
                    top: "50%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    transform: "translate(-50%, -50%)",
                    color: "red",
                    width: '400px'
                },
            }            
        };
    }

    componentDidMount = async () => {
        const unHashedJwt = await checkJwt();

        if (!unHashedJwt) {
            logout();
        }

        Modal.setAppElement('body');

        await this.GetProviderList();
    };

    GetProviderList = async () => {
        this.setState({ loading: true})

        const unHashedJwt = await checkJwt();

        if (!unHashedJwt) {
            logout();
        }

        const providerList = await GetProviders(this.props.activePage, this.props.pageSize, this.props.activeOnly);

        await this.props.mapState("MAP_PROVIDER_LIST", providerList.data.data);

        // pregledaj da li su svi u listi izbrisani
        this.props.providerList.providers.map((data, index) =>{
            if(data.deleted === ""){
               this.setState({ brojacAktivni: 1 })
            }
            return null;
        })

        await this.setState({ loading: false})
    };

    handleChange(e) {
        this.setState({
            [e.target.id]: e.target.value,
        });
    }

    handlePageChange(pageNumber) {

        this.props.mapState("MAP_PROVIDER_LIST_ACTIVE_PAGE", pageNumber);

        this.GetProviderList();
    }

    handleItemsPerPageChange(itemsPerPage) {
        this.setState({ itemsPerPage: itemsPerPage });

        this.GetProviderList();
    }

    onItemsPerPageChange = async (size) => {
        this.props.mapState("MAP_PROVIDER_LIST_PAGE_SIZE", size);
        this.props.mapState("MAP_PROVIDER_LIST_ACTIVE_PAGE", 1);
        this.GetProviderList();
    };

    seeDetails = async (data) => {
        //this.props.mapState("MAP_ONE_PROVIDER_DETAILS", data);
        await history.push("providers/:" + data.uuid)
    }

    showModal = (uuid) => {
        this.setState({
            showModal: !this.state.showModal,
            uuidForDelete: uuid,
        });
    };

    confirmDelete = async () => {
        const { t } = this.props  
        let deleteSelected = await deleteProvider(this.state.uuidForDelete);
        if (deleteSelected.data !== null) {
            await this.setState({
                showModal: false,
            });
            store.addNotification({
                title: t("Success!"),
                message: t("You have successfully deleted the provider"),
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true,
                },
            });

            await this.GetProviderList();
        } else {
            await this.setState({
                showModal: false,
            });
            store.addNotification({
                title: this.props.t("Error!"),
                message: t("An error has occurred, please try again"),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true,
                },
            });
        }
    };
    
    prikaziSakrij = (data) => {

        this.props.mapState("TOGGLE_PROVIDER_VISIBLE_COLUMN", data)
    }

    toggleOnlyActive= async (data) => {
        this.setState({
            loading: true
        })

        await this.props.mapState("MAP_PROVIDER_ACTIVE_ONLY", data)
        await this.GetProviderList();       
    }

    render() {
        const { t } = this.props;

        const columns = [
            {
                dataField: "full_name",
                text: t("Name"),
                headerStyle: { wordWrap: "break-word" },
                hidden: this.props.user.user_web_properties.columns.provider.main.full_name,
            },
            {
                dataField: "email",
                text: t("Email"),
                headerStyle: { wordWrap: "break-word" },
                hidden: this.props.user.user_web_properties.columns.provider.main.email,
            },
            {
                dataField: "phone_number",
                text: t("Phone Number"),
                headerStyle: { wordWrap: "break-word" },
                hidden: this.props.user.user_web_properties.columns.provider.main.phone_number,
            },
            {
                dataField: "address",
                text: t("Address"),
                headerStyle: { wordWrap: "break-word" },
                hidden: this.props.user.user_web_properties.columns.provider.main.address,
            },
            {
                dataField: "countries",
                text: t("Countries"),
                hidden: this.props.user.user_web_properties.columns.provider.main.countries,
                formatter: (cellContent, row) => {
                    return (
                        <div
                            key={row.uuid}
                            className="word-wrap"
                        >
                            {row.countries.map((data, index) => {
                                return (
                                    <span key={index}>
                                        {data.country_name}&nbsp;
                                    </span>
                                );
                            })}
                        </div>
                    );
                },
            },
            {
                dataField: "deleted",
                text: t("Deleted"),
                headerStyle: { wordWrap: "break-word" },
                hidden: this.props.user.user_web_properties.columns.provider.main.deleted,
            },
            {
                dataField: "created",
                text: t("Created"),
                headerStyle: { wordWrap: "break-word" },
                hidden: this.props.user.user_web_properties.columns.provider.main.created,
            }            
        ]

        // ako netko nije izbrisan prikazi stupc za editiranje i brisanje
        if(this.state.brojacAktivni > 0 ){
            columns.push({               
                style: { width: "11.8em" },
                dataField: "sakriveno",
                text: '',
                formatter: (cellContent, row) => {
                    return (
                        row.deleted === "" ?
                            <div key={uuidv4()}>
                                <Button
                                    variant="success"
                                    className="btnDetalji me-2"
                                    onClick={() => this.seeDetails(row)}
                                >
                                    <AiFillEdit /> {t("Details")}
                                </Button>

                                <Button
                                    variant="danger"
                                    className="btnIzbrisi"
                                    onClick={() => this.showModal(row.uuid)}
                                >
                                    <RiDeleteBin5Line /> {t("Delete")}
                                </Button>
                                
                            </div>
                        : null 
                    );
                }
            })
        }

        /* CUstom filter buttons */
        const CustomToggleList = ({ columns, onColumnToggle, toggles}, customFunkcija) => {

            //asiknrona funkcija za poziv default toggler funkcije + sprmenje promjene za poziv prema serveru
            customFunkcija = async (column) => {
                await onColumnToggle(column.dataField)
                let data = { menu: "provider", view: "main" , column: column.dataField }
                await this.props.mapState("USER_MAP_COLUMNS", data)
                await updateUser(
                    this.props.user,
                    this.props.user.provider_uuid
                )
            }

            if(isMobile){
                return <Dropdown className="sortBy columnTogglerButton">
                    <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                    >
                        {t('Columns')}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                    {columns
                        .filter(data => data.dataField !== "sakriveno")
                        .map(column => ({
                        ...column,
                        toggle: toggles[column.dataField]
                    }))
                    .map((column) => (
                            <Dropdown.Item
                                key = {column.dataField}
                                className={ ` ${column.toggle ? 'aktivan' : 'neaktivan'}` }
                                data-toggle="button" 
                                label={column.text}
                                id={column.dataField}
                                aria-pressed={(column.toggle) ? "true" : "false"}
                                onClick={() => customFunkcija(column) }
                            > 
                                {column.text}
                        </Dropdown.Item>
                        ))}
                    </Dropdown.Menu>
                </Dropdown> 
            }

            else{
                return <div className="btn-group btn-group-toggle " data-toggle="buttons">
                {columns
                  .filter(data => data.dataField !== "sakriveno")
                  .map(column => ({
                    ...column,
                    toggle: toggles[column.dataField]
                  }))
                  .map((column) => (
                      <button                         
                          key = {column.dataField}
                          type="button" 
                          className={ ` ${column.toggle ? ' btn btn-success active' : 'btn btn-danger'}` }
                          data-toggle="button" 
                          label={column.text}
                          id={column.dataField}
                          aria-pressed={(column.toggle) ? "true" : "false"}
                          onClick={() => customFunkcija(column) }
                      >
                              {column.text}
                      </button>
                  ))}
              </div>
            }
        };

        return (
            <>
                {this.state.loading ? (
                    <Loader />                  
                ) : this.props.providerList.providers.length > 0 ? (
                    <>
                        <ToolkitProvider
                            keyField="uuid"
                            data={this.props.providerList.providers}
                            columns={columns}
                            columnToggle     
                            prikaziSakrij = {this.prikaziSakrij}   
                            striped={true}                 
                        >
                            {(props) => (
                                <>
                                    <Col sm={8} className="pb-4">
                                        <CustomToggleList {...props.columnToggleProps} />
                                    </Col>
                                   
                                    <div className="table-responsive">
                                        <BootstrapTable {...props.baseProps} hover bodyClasses="table-body" />
                                    </div>
                                </>
                            )}
                        </ToolkitProvider>
                        <br />
                        <div className="container">
                            <div className="row justify-content-md-center m-0 pt-1">
                                <div className="col-2">
                                    <ButtonWithDropdown 
                                        itemsPerPage={[10, 20, 30, 50]}
                                        active={this.props.pageSize}
                                        onItemsPerPageChange={this.onItemsPerPageChange}
                                        className="itemsPerPage"
                                        toggleId="dropdown-basic"
                                        styleToggle={{width:"auto"}}
                                    />
                                </div>
                                
                                <div className="col-8 text-center">
                                    <Pagination
                                        className="pagination"
                                        firstPageText="1"
                                        lastPageText={Math.ceil(
                                            this.props.providerList.total_number_of_records /
                                                this.props.pageSize
                                        ).toString()}
                                        hideDisabled
                                        activePage={this.props.activePage}
                                        itemsCountPerPage={this.props.pageSize}
                                        totalItemsCount={this.props.providerList.total_number_of_records}
                                        pageRangeDisplayed={5}
                                        onChange={this.handlePageChange.bind(this)}
                                        breakClassName={'page-item'}
                                        itemClass="page-item"
                                        linkClass="page-link"
                                    />
                                </div>

                                <div className="col-2">
                                    <ButtonWithDropdown 
                                        itemsPerPage={["All", "Active", "Inactive"]}
                                        active={this.props.activeOnly}
                                        onItemsPerPageChange={this.toggleOnlyActive}
                                        toggleId="dropdown-basic"
                                        className="itemsPerPage" 
                                        styleToggle={{
                                            float:"right",
                                            width: "auto"
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <ddiv className="list-empty-container">
                        <h3>{t(this.props.message)}</h3>
                    </ddiv>
                )}

                <Modal
                    isOpen={this.state.showModal}
                    onRequestClose={() => this.showModal("")}
                    style={this.state.customStyles}
                    ariaHideApp={false}
                >
                     <h3 className="modal-title">{t('Warning!')}</h3>
                    
                    <div className="mb-4">
                        <p>
                        {t(
                            "Deleting the Provider also deletes all data related to it"
                        )}
                        .</p>
                    </div>

                    <Row>
                        <Col sm={6}>
                            <Button
                                variant="primary"
                                onClick={() => this.showModal("")}
                            >
                                {t("Close")}
                            </Button>
                        </Col>
                        <Col sm={6}>
                            <Button
                                variant="danger"
                                onClick={() => this.confirmDelete()}
                            >
                                {t("DELETE")}
                            </Button>
                        </Col>
                    </Row>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        providerList: state.provider.providersList,
        pageSize: state.provider.pageSize,
        activePage: state.provider.activePage,
        loading: state.provider.loadingProviders,
        message: state.provider.message,
        providerVisibleColumns: state.provider.providerVisibleColumns,
        activeOnly: state.provider.activeOnly,
        user: state.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data }),
        API: (type, data) => dispatch({ type: type, data: data }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(ProviderList));
